__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-28-1787914505-stable-dev/";